import { render } from "./PreApprovalStep1.vue?vue&type=template&id=644611da&scoped=true"
import script from "./PreApprovalStep1.vue?vue&type=script&lang=js"
export * from "./PreApprovalStep1.vue?vue&type=script&lang=js"

import "./PreApprovalStep1.vue?vue&type=style&index=0&id=644611da&scoped=true&lang=scss"

import exportComponent from "D:\\Epaylater Projects\\microapp-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-644611da"]])

export default __exports__